import { useOiStore } from '@/lib/store/oi';
import { OIList } from './OIList';
import { OIDetail } from './OIDetail';

export function OIContext({ onSelect }: { onSelect?: () => void }) {
  const selectedId = useOiStore((s) => s.selectedId);
  return selectedId ? <OIDetail id={selectedId} /> : <OIList onSelect={onSelect} />;
}
